<template>
    <Page type="gray" :nopadding="true">
        <template v-slot:body>
            <Accounts :wallet="account" :loading="loading"/>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import Page         from    '@/components/sides/Page.vue' 
import Accounts     from    '@/components/personal/Accounts.vue' 
import { useRoute } from 'vue-router'

export default {
    data() {
        return {
            account: null,
            totalRecords: 0,
            totalAmount: 0,
        }
    },
    components: {
        Page,
        Accounts
    },
    methods: {
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        get_short_id(value){
            if(!value) return ''
            return this.helper.get_short_id(value)
        },
        detail_page(id, type='account', new_tab = false) {
            if(new_tab){
                const routeData = this.$router.resolve({path: '/admin/'+type+'/' + id});
                window.open(routeData.href, '_blank');
            } else  this.$router.push({ path: '/admin/'+type+'/' + id })
        },
        onPage(event) {
            this.lazyParams = event
            this.loadLazyData()
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.loadLazyData();
        },
        async loadLazyData() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
            const account_data = await this.connect.get_account(this.merchant_id, this.lazyParams.rows, this.lazyParams.first).then(res=>res)
            if(account_data.result) {
                this.account = account_data.data
                this.totalRecords = account_data.total
                let totalAmount = new BigNumber(0)
                if(account_data.data.trans && account_data.data.trans.length>0){
                    account_data.data.trans.forEach(element => {
                        let amount = new BigNumber(element.amount.$numberDecimal)
                        if(element.direction=='in') totalAmount = totalAmount.plus(amount)
                        else totalAmount = totalAmount.minus(amount)
                    })
                }
                this.totalAmount = this.helper.format_amount(totalAmount, account_data.data.currency)
            }
            this.loading = false
        },
    },
    async mounted() {
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        this.loadLazyData()
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.merchant_id = route.params.id
            this.loadLazyData()
        }
    },
}
</script>